<div class="page-wrapper">
  <div class="page-content">
    <div class="title-wrapper">
      <h1>{{$Locale.get("agents/title")}}</h1>
      <button mat-stroked-button (click)="insertAgentsFromCsv()">
        <mat-icon>group_add</mat-icon>{{$Locale.get("agents/update")}}
      </button>
    </div>
    <div class="panel-wrapper">
      <p *ngIf="data && data.length > 0" class="panel-title">Found a total of <b>{{data.length}}</b> brokers in the system.</p>
      <div class="table-wrapper">
        <app-agents-table *ngIf="data && data.length > 0" [dataObservable]="dataSubject.asObservable()" [data]="data"></app-agents-table>
        <p *ngIf="(data && !data.length) || !data" class="empty-data-title">
          <mat-icon>error_outline</mat-icon>
          {{$Locale.get("agents/no_records")}}
        </p>
      </div>
    </div>
  </div>
</div>
